import { type NameField } from '../../../types/graphql.form.ts'
import { type InputProps } from './index.tsx'
import Input from './input.tsx'

export default function InputName({ field }: InputProps) {
	const name = field as NameField
	// could have as many as 4
	const isFirst = Boolean(name.firstNameEnabled)
	const isMiddle = Boolean(name.middleNameEnabled)
	const isLast = Boolean(name.lastNameEnabled)
	const isPrefix = Boolean(name.prefixEnabled)
	// const numberOfFields = [isFirst, isMiddle, isLast, isPrefix].filter((t) =>
	// 	Boolean(t),
	// ).length

	return (
		<div className="full row">
			{isPrefix && (
				<Input
					type="text"
					name={name.name}
					displayName={name.displayName}
					placeholder={name.prefixPlaceholder}
					required={Boolean(name.prefixRequired)}
					defaultValue={name.prefixDefaultValue}
					uid={name.uid}
					visibility={name.visibility}
					className="col-span-1"
					error={null}
					handle={name.handle}
					labelPosition={field.labelPosition}
				/>
			)}
			{isFirst && (
				<Input
					type="text"
					name={name.name}
					displayName={name.displayName}
					placeholder={name.firstNamePlaceholder}
					required={Boolean(name.firstNameRequired)}
					defaultValue={name.firstNameDefaultValue}
					uid={name.uid}
					visibility={name.visibility}
					className="half"
					error={null}
					handle={name.handle}
					labelPosition={field.labelPosition}
				/>
			)}
			{isMiddle && (
				<Input
					type="text"
					name={name.name}
					displayName={name.displayName}
					placeholder={name.middleNamePlaceholder}
					required={Boolean(name.middleNameRequired)}
					defaultValue={name.middleNameDefaultValue}
					uid={name.uid}
					visibility={name.visibility}
					className="half"
					error={null}
					handle={name.handle}
					labelPosition={field.labelPosition}
				/>
			)}
			{isLast && (
				<Input
					type="text"
					name={name.name}
					displayName={name.displayName}
					placeholder={name.lastNamePlaceholder}
					required={Boolean(name.lastNameRequired)}
					defaultValue={name.lastNameDefaultValue}
					uid={name.uid}
					visibility={name.visibility}
					className="half"
					error={null}
					handle={name.handle}
					labelPosition={field.labelPosition}
				/>
			)}
		</div>
	)
}
